import HomeImg1 from "./Images/HomeImg1.webp";
import Bab1 from "./Images/Bab1.webp";
import Mat5 from "./Images/Mat5.webp";
import Out1 from "./Images/Out1.webp";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="imgcontainer">
      {/* Wedding */}
      <div className="row">
        <Link to="/wedding" className="image-with-content">
          <img src={HomeImg1} alt="wedding" loading="lazy" />
          <div className="content">
            <div className="quote">- WEDDINGS</div>
            <div className="titlee">A Forever Promise!</div>
          </div>
        </Link>
      </div>

      {/* Outdoor */}
      <div className="row">
        <Link to="/outdoor" className="image-with-content">
          <img src={Out1} alt="Outdoor" loading="lazy" />
          <div className="content">
            <div className="quote">- OUTDOOR SHOOT</div>
            <div className="titlee">Ready to share your love story?</div>
          </div>
        </Link>
      </div>

      {/* Baby Shoot */}
      <div className="row">
        <Link to="/babyshoot" className="image-with-content">
          <img src={Bab1} alt="Baby" loading="lazy" />
          <div className="content">
            <div className="quote">- BABY SHOOT</div>
            <div className="titlee">Life's little treasures!</div>
          </div>
        </Link>
      </div>

      {/* Maternity */}
      <div className="row">
        <Link to="/maternity" className="image-with-content">
          <img src={Mat5} alt="maternity" loading="lazy" />
          <div className="content">
            <div className="quote">- MATERNITY SHOOT</div>
            <div className="titlee">Moments to cherish forever!</div>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Home;
